export default __webpack_public_path__ + "51fcc0ed4fef7018a0e24a4480071751.png";